<template>
    <div>
        <div style="height: 90px; width: 100%; position: absolute;">
          <div>
            <img
              class="fanhui"
              @click="goOff()"
              style="margin-top: 5px"
              src="../assets/images/fanhuizhong.png"
            />
          </div>
        </div>
        <div class="diyi">
            <img class="courseCover" :src="cover" />
        </div>
        <div><h3 class="title">{{ name }}</h3></div>
        <div class="biaoshi_kcb">课程包</div>
        <div class="course">
            <div class="quanbukechena">
                <div v-for="item in lista" :key="item.id" class="one">
                    <div class="img-box">
                        <img class="tuimg" :src="item.cover" alt="" />
                        <!-- <div
                            class="con-audio"
                            @click="handleTolivingPage(item)"
                            v-if="item.chapterStatus == 2&&showLivingIcon"
                        >
                            <section>
                            <span></span>
                            <span></span>
                            <span></span>
                            </section>
                        </div> -->
                        <div class="mask" v-if="item.chapterStatus == 2&&showLivingIcon"></div>
                    </div>
                    <p class="shujuzhibiao">{{ item.name }}</p>
                    <p class="dijiqi">{{ item.period }}</p>
                    <p v-if="item.start_time" class="kaikeshijian">开课：{{ item.start_time.substring(0, 16) }}</p>
                    <span class="f" v-if="item.endNum <= 0">开始学习</span>
                    <router-link
                    v-if="Isitthehomepage == 2"
                        :to="{
                            path: 'zhibo',
                            query: { setid: item.course_id, class_id: item.class_id },
                        }"
                    >
                        <div v-if="item.endNum <= 0" class="f_d">
                            <a href="#" style="color: #1872ed">开始学习</a>
                        </div>
                        <div v-else-if="item.endNum >= 1"><a href="#">开始学习</a></div>
                    </router-link>
                    <router-link
                    v-else
                        :to="{
                            path: 'zhibo',
                            query: { setid: item.id },
                        }"
                    >
                        <div><a href="#">开始学习</a></div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { mapGetters } from "vuex";
    export default {
      data() {
        return {
          lista: [],
          cover: '',
          name: '',
          Isitthehomepage: 1
        }
      },
      computed: {
        ...mapGetters({
          org_id: "user/getOrgId"
        }),
      },
      created() {
        console.log('23151===', this.$route.query.setid)
        this.getCorseFromPackage()
        this.cover = this.$route.query.cover
        this.name = this.$route.query.name
        this.Isitthehomepage = this.$route.query.Isitthehomepage
      },
      methods: {
        getCorseFromPackage() {
          const data = {
            packid: this.$route.query.id
          }
          if (this.$route.query.Isitthehomepage == 1) {
            data.uid = this.org_id
          }
          const prehy = this.$route.query.Isitthehomepage == 1 ? '/app/getCorseFromPackage' : '/app/getAccessCorseFromPackage'
          this.$api.post(process.env.VUE_APP_API_PRDHY + prehy,data)
          .then(res=>{
            if(res.data.code == 200){
              this.lista = res.data.data.list
            }
          })
        },
        goOff() {
            this.$router.go(-1);
        },
      },
    }
</script>
<style scoped>
.title {
  font-size: 20px;
  color: #202020;
  margin-bottom: 6px;
  margin-top: 6px;
  margin-left: 12px;
}
.diyi .courseCover {
  z-index: 3000;
  width: 100%;
  height: 200px;
}
.diyi {
  width: 100%;
  height: 5.33rem;
  overflow: hidden;
  background: #fff;
  position: relative;
}
.fanhui {
  width: 25px;
  height: 25px;
  opacity: 0.5;
  background: #000000;
  border-radius: 50%;
  text-align: center;
  top: 10px;
  left: 10px;
  position: absolute;
  z-index: 9999;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

a {
  text-decoration: none;
}

.course .one .img-box {
  width: 3.2rem;
  height: 2.35rem;
  float: left;
  margin-top: 0.43rem;
  margin-left: 0.16rem;
  position: relative;
  border: none;
  margin-bottom: 0.43rem;
}

.course .one .mask {
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 9px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
}

.course .one .img-box .con-audio {
  display: flex;
  align-items: center;
  justify-content: center;
  animation: backColor 4s infinite;
  border-radius: 0%;
  width: 2rem;
  height: 0.5rem;
  border: none;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0;
  transform: translate(-50%, -50%);
  z-index: 2;
  /* overflow: hidden; */
}

.course .one .img-box .con-audio section {
  width: max-content;
  height: auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.course .one .img-box .con-audio span:nth-child(1) {
  width: 0.1rem;
  height: 0.36rem;
  /* margin-left: 3px; */
  border-radius: 0.08rem;
  display: inline-block;
  position: relative;
  background: #4abb96;
  color: #4abb96;
  animation: loading 0.4s 0.3s linear infinite alternate;
  animation-play-state: running;
  margin: 0;
}

.course .one .img-box .con-audio span:nth-child(2) {
  margin: 0;
  width: 0.1rem;
  height: 0.36rem;
  margin-left: 0.08rem;
  border-radius: 0.08rem;
  display: inline-block;
  position: relative;
  background: #4abb96;
  color: #4abb96;
  animation: loading 0.5s 0.5s linear infinite alternate;
  animation-play-state: running;
}

.course .one .img-box .con-audio span:nth-child(3) {
  margin: 0;
  width: 0.1rem;
  height: 0.36rem;
  margin-left: 0.08rem;
  border-radius: 0.08rem;
  display: inline-block;
  position: relative;
  background: #4abb96;
  color: #4abb96;
  animation: loading 0.6s 0.8s linear infinite alternate;
  animation-play-state: running;
}

@keyframes loading {
  0% {
    height: 18px;
    transform: translateY(0);
  }

  100% {
    height: 5px;
    transform: translateY(7.5px);
  }
}

.tuimg {
  width: 3.2rem;
  height: 2.35rem;
}

.titlist {
  width: 100%;
  height: 1.17rem;
  background-color: #ffffff;
  overflow: hidden;
}

.titlist h1 {
  height: 24px;
  font-size: 17px;
  font-weight: 600;
  color: #101010;
  line-height: 24px;
  text-align: center;
  margin-top: 0.24rem;
  margin-bottom: 0.29rem;
}

.shujuzhibiaos {
  /* word-break: keep-all;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis; */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 0.4rem;
  font-weight: 500;
}

.meal {
  width: 100%;
  background: #f5f5f5;
}

.meal ul li {
  float: left;
  list-style-type: none;
  padding: 14px 0;
}

.meal ul li a {
  width: 56px;
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #101010;
  line-height: 20px;
  padding: 0px 14px;
}

.course {
  margin-top: 10px;
  background: #f6f6f6;
  /* min-height: 406px; */
  /* width: 9.47rem; */
  /* background: #fff; */
  border-radius: 10px;
  overflow: hidden;
  /* margin-left: 0.27rem;
  margin-right: 0.27rem;
  margin-top: 0.27rem; */
}

.quanbukechena {
  /* background-color: #fff; */
  margin-bottom: 10px;
}

.course .one {
  /* height: 3.1rem; */
  margin: 10px 10px;
  overflow: hidden;
  background-color: #fff;
  border-radius: 10px;
  /* margin-bottom: 0.47rem; */
}

.coursebx {
  display: flex;
  margin-bottom: 0.625rem;
  margin-left: 0.16rem;
  align-items: center;
}

.course .one img {
  float: left;
  border-radius: 9px;
}

.course .one p {
  float: left;
  width: 4.91rem;
  margin-left: 0.32rem;
}

.course .one .f {
  margin-top: 0.11rem;
  margin-left: 0.32rem;
  float: left;
  font-size: 12px;
  font-weight: 400;
  color: #ff8500;
  line-height: 17px;
}

.course .one span {
  float: left;
  font-size: 12px;
  font-weight: 400;
  color: #10a675;
  line-height: 17px;
  margin-top: 0.21rem;
  margin-left: 0.32rem;
}

.progressbx {
  width: 100%;
  position: relative;
}

.course .one .f_d {
  float: right;
  width: 1.92rem;
  height: 0.64rem;
  border-radius: 16px;
  text-align: center;
  line-height: 0.64rem;
}

.course .one div {
  float: right;
  width: 1.92rem;
  height: 0.64rem;
  border: 1px solid #1872ed;
  border-radius: 16px;
  text-align: center;
  line-height: 0.64rem;
  margin-right: 0.48rem;
}

.tuimgs {
  width: 3.2rem;
  height: 2.5rem;
  border-radius: 0.3125rem;
}

.course .one div a {
  font-size: 12px;
  font-weight: 400;
  color: #1872ed;
}

.ylook {
  margin-bottom: 10px;
  margin-top: 20px;
  font-size: 0.32rem;
}

.bfb {
  position: absolute;
  top: -5px;
  right: 5px;
}

.centon {
  flex: 1;
  margin-left: 10px;
}

::v-deep .van-progress {
  width: 80%;
}

.one:last-child {
  /* margin-bottom: 0.43rem; */
  border-radius: 0px 0px 9px 9px;
}

.onelisr:last-child {
  /* margin-bottom: 0.43rem; */
  border-radius: 0px 0px 9px 9px;
}

.shujuzhibiao {
  margin-top: 0.43rem;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.43rem;
  font-weight: 600;
}

.dijiqi {
  font-weight: 400;
  color: #888888;
  font-size: 0.32rem;
  margin-top: 0.11rem;
}

.kaikeshijian {
  font-weight: 400;
  color: #888888;
  font-size: 0.32rem;
  margin-top: 0.11rem;
}
.biaoshi_kcb {
  width: 39px;
  height: 18px;
  border: 0.5px solid #4abb96;
  border-radius: 2px;
  font-size: 11px;
  font-family: PingFang SC, PingFang SC-Regular;
  color: #4abb96;
  text-align: center;
  line-height: 16px;
  margin-right: 3px;
  margin-left: 12px;
}
</style>
